import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import HistorySection, { useHistory } from "@/components/HistorySection";

const History = () => {
  const { t } = useLanguage();
  const h = useHistory();
  return (
    <main className="min-h-screen" data-testid="history-page">
      <Seo page="history" />
      <section className="relative overflow-hidden bg-mint/60 pb-16 pt-36">
        <div className="pointer-events-none absolute -right-32 -top-20 h-[26rem] w-[26rem] rounded-full bg-cream blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
          <SectionHead as="h1" overline={h.overline} title={h.title} accent={h.accent} sub={h.intro} />
        </div>
      </section>
      <HistorySection />
      <section className="bg-brand py-20" data-testid="history-cta">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-5 sm:flex-row sm:items-center sm:px-8">
          <Reveal>
            <h2 className="font-display text-2xl font-bold text-white sm:text-3xl">{t.cta.title} <span className="text-gold">{t.cta.titleAccent}</span></h2>
          </Reveal>
          <Reveal delay={0.15}>
            <Link to="/contact" data-testid="history-cta-button" className="group inline-flex items-center gap-3 rounded-full bg-gold px-7 py-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-white shadow-xl shadow-forest/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold-hover">
              {t.cta.button}<ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default History;
